<template>
  <!-- 发布活动页面 -->
  <div class="page-container">
    <!-- 页面头部 -->
    <div>
      <div class="page-card__header">
        <span style="padding-right: 20px"> 发布活动</span>
      </div>
    </div>
    <div style="padding: 20px">
      <el-form ref="form" :model="form" :rules="rules" label-width="80px" >

        <!-- LOGO预览与上传 -->
        <el-image v-if="form.logo !== ''"
                  :src="imgUrl+form.logo" style="width: 200px;height: 200px"></el-image>
        <el-form-item prop="img" label-width="0px">
          <el-upload
            class="avatar-uploader"
            :action="imagesrc"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :headers="headers"
            :before-upload="beforeAvatarUpload">
            <el-button size="small" type="primary" round>点击上传LOGO</el-button>
            <div slot="tip" class="el-upload__tip">最佳展示尺寸：1:1，建议500 x 500像素以上</div>
          </el-upload>
        </el-form-item>

        <!-- 基本信息表单 -->
        <el-form-item label="标题" prop="title">
          <el-input v-model="form.title"></el-input>
        </el-form-item>
        <el-form-item label="公司名" prop="company">
          <el-input v-model="form.company"></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="desc">
          <el-input v-model="form.desc"></el-input>
        </el-form-item>
        <el-form-item label="主讲人" prop="host">
          <el-input v-model="form.host"></el-input>
        </el-form-item>
        <el-form-item label="职位" prop="position">
          <el-input v-model="form.position"></el-input>
        </el-form-item>
        <el-form-item label="举办方式" prop="type" style="text-align: left">
          <el-radio-group v-model="form.type">
            <el-radio label="线上">线上</el-radio>
            <el-radio label="线下">线下</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="时间" prop="start_time">
          <el-col :span="5">
            <el-form-item label="" prop="start_time">
              <el-date-picker
                type="datetime"
                placeholder="选择开课日期"
                v-model="form.start_time"
                style="width: 100%"
                value-format="yyyy-MM-dd HH:mm:ss"
              ></el-date-picker>
            </el-form-item>
          </el-col>

          <el-col class="line" :span="2">-</el-col>

          <el-col :span="5">
            <el-form-item label="" prop="end_time">
              <el-date-picker
                type="datetime"
                placeholder="选择结课日期"
                v-model="form.end_time"
                style="width: 100%"
                value-format="yyyy-MM-dd HH:mm:ss"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-form-item>

        <el-form-item label="地址" prop="address">
          <el-input v-model="form.address"></el-input>
        </el-form-item>

        <!-- 活动内容编辑 -->
        <el-form-item label="内容" prop="info">
          <tiny-editor
            v-model="form.info"
            :init="init"
            id="textarea"
          ></tiny-editor>
        </el-form-item>

        <!-- <el-form-item label="内容" prop="info">
          <vue-html5-editor
            :content="form.info"
            :height="300"
            v-model="form.info"
            :show-module-name="showModuleName"
            @change="updateData"
            ref="editor"
          ></vue-html5-editor>
        </el-form-item> -->

        <!-- 提交按钮区域 -->
        <el-form-item>
          <el-col :span="12" style="text-align: right; padding-right: 10px">
            <el-button
              type="primary"
              round
              size="small"
              @click="onBaseSubmit('form')"
            >发布活动
            </el-button
            >
          </el-col>
          <el-col :span="12" style="text-align: left; padding-left: 10px">
            <el-button type="danger" round size="small" @click="back"
            >取消返回
            </el-button
            >
          </el-col>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
  import editor from "@tinymce/tinymce-vue";
  import {VueEditor} from "vue2-editor";
  import api from "../../utils/api";

  export default {
    components: {
      VueEditor,
      "tiny-editor": editor,
    },
    name: "addActivity",
    data() {
      return {
        init: {
          // 配置信息
          selector: "#textarea",
          height: 550,
          language_url: "/static/tinymce/langs/zh-Hans.js", // 中文包的存放路径
          language: "zh-Hans",
          // skin_url: 'static/js/tinymce/skins/ui/oxide-dark',
          // content_css: 'static/js/tinymce/skins/content/dark/content.min.css',
          menubar: true,
          // plugins: "image",
          image_dimensions: false,
          images_upload_url:
            "https://cloudexhibition.chinafastenerinfo.com/api/admin/uploadfile/news/",
          images_upload_base_path:
            "https://cloudexhibition.oss-cn-shenzhen.aliyuncs.com/news/",

          plugins: [
            "advlist autolink lists link image imagetools charmap print preview anchor textcolor imageupload",
            "searchreplace visualblocks code fullscreen ",
            "insertdatetime media table contextmenu paste code help wordcount",
          ],
          toolbar:
            "preview link code insertdatetime  charmap | media  image | undo redo |  formatselect | bold italic backcolor  | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent  | removeformat | help",
          automatic_uploads: true,
          images_upload_handler: function (blobInfo, succFun, failFun) {
            var xhr, formData;
            var file = blobInfo.blob(); //转化为易于理解的file对象
            xhr = new XMLHttpRequest();
            xhr.withCredentials = true;
            xhr.open(
              "POST",
              "https://cloudexhibition.chinafastenerinfo.com/api/admin/uploadfile/news/"
            );

            // 设置请求头
            xhr.setRequestHeader(
              "Authorization",
              "JWT " + localStorage.getItem("adminToken")
            );
            xhr.setRequestHeader("XMLHttpRequest", "HeaderValue");

            xhr.onload = function () {
              var json;
              if (xhr.status != 200) {
                failFun("HTTP Error: " + xhr.status);
                return;
              }
              json = JSON.parse(xhr.responseText);
              // if (!json || typeof json.location != "string") {
              //   failFun("Invalid JSON: " + xhr.responseText);
              //   return;
              // }
              succFun(
                "https://cloudexhibition.oss-cn-shenzhen.aliyuncs.com/news/" +
                json.filename
              );
            };
            formData = new FormData();
            formData.append("file", file, file.name); //此处与源文档不一样
            xhr.send(formData);
          },
        },
        headers: {"Authorization": "JWT " + localStorage.getItem('adminToken')},
        imagesrc: this.baseUrl + "/admin/uploadfile/activity/",
        imgUrl: 'https://cloudexhibition.oss-cn-shenzhen.aliyuncs.com/activity/',
        showModuleName: true,
        form: {
          logo: '',
          title: "",
          type: "",
          company: '',
          position: '',
          address: "",
          desc: "",
          host: "",
          info: "",
          start_time: "",
          end_time: "",
        },
        newimgUrl: "https://cloudexhibition.oss-cn-shenzhen.aliyuncs.com/news/",


        rules: {
          title: [{required: true, message: "请输入活动名称", trigger: "blur"}],
          type: [{required: true, message: "请选择活动类型", trigger: "blur"}],
          address: [
            {required: true, message: "请输入活动地址", trigger: "blur"},
          ],
          company: [{
            required: true, message: "请输入公司名", trigger: "blur"
          }],
          position: [{
            required: true, message: "请输入职位", trigger: "blur"
          }],
          desc: [{required: true, message: "请输入描述", trigger: "blur"}],
          host: [{required: true, message: "请输入主讲人", trigger: "blur"}],
          info: [{required: true, message: "请输入活动内容", trigger: "blur"}],
          start_time: [
            {required: true, message: "请选择开始时间", trigger: "blur"},
          ],
          end_time: [
            {required: true, message: "请选择结束时间", trigger: "blur"},
          ],
        },
      };
    },
    methods: {
      // 提交发布活动表单
      onBaseSubmit(formname) {
        this.$refs[formname].validate((valid) => {
          if (valid) {
            let url = this.baseUrl + "/admin/activitys/";
            api
              .postData(url, {
                title: this.form.title,
                type: this.form.type,
                address: this.form.address,
                desc: this.form.desc,
                logo:this.form.logo,
                company: this.form.company,
                position: this.form.position,
                host: this.form.host,
                info: this.form.info,
                start_time: this.form.start_time,
                end_time: this.form.end_time,
                share: 0,
                view: 0,
                praise: 0,
              })
              .then((res) => {
                this.$message({
                  message: "添加活动成功",
                  type: "success",
                });
                this.$router.push({name: "admin_activityList"});
              });
          }
        });
      },

      // 更新富文本编辑器内容
      updateData: function (data) {
        // sync content to component
        this.form.info = data;
      },
      // 富文本编辑器上传图片回调函数
      handleImageAdded(file, Editor, cursorLocation, resetUploader) {
        let url = this.baseUrl + "/admin/uploadfile/news/";
        const formData = new FormData();
        formData.append("file", file);
        api.postData(url, formData).then((res) => {
          Editor.insertEmbed(
            cursorLocation,
            "image",
            this.newimgUrl + res.filename
          );
          resetUploader();
        });
      },
      // 返回活动列表页
      back() {
        this.$router.push({name: "admin_activityList"});
      },

      // 图片上传成功回调
      handleAvatarSuccess(res, file) {

        let imageUrl = URL.createObjectURL(file.raw);
        this.form.logo = res.filename;

      },
      // 图片上传前校验
      beforeAvatarUpload(file) {
      }
    },
  };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/admin/addActivity.vue